import { accordionArrow } from "./Static/accordionArrow";
import React, { useRef, useState } from "react";
import { roundText } from "./Static/roundText";

const Accordion = ({ isOpen, onClick }) => {
    const contentHeight = useRef();

    return (
        <div className="accordion round-normal" onClick={onClick}>
            <div className="accordion-heading">
                <div className="accordion-heading-wrapper">
                    <h3>
                        {roundText}
                        <span>2</span>
                    </h3>
                    <span className="in-brackets">[во живо]</span>
                </div>

                <div className="accordion-badges-button-wrapper">
                    <div className="badges-wrapper">
                        <div className="accordion-badge date-badge">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="18"
                                viewBox="0 0 17 18"
                                fill="none"
                            >
                                <path
                                    d="M3.54167 16.0833C3.15208 16.0833 2.81858 15.9446 2.54115 15.6672C2.26372 15.3897 2.125 15.0562 2.125 14.6667V4.74999C2.125 4.36041 2.26372 4.0269 2.54115 3.74947C2.81858 3.47204 3.15208 3.33332 3.54167 3.33332H4.25V2.62499C4.25 2.4243 4.31788 2.25607 4.45365 2.1203C4.58941 1.98454 4.75764 1.91666 4.95833 1.91666C5.15903 1.91666 5.32726 1.98454 5.46302 2.1203C5.59878 2.25607 5.66667 2.4243 5.66667 2.62499V3.33332H11.3333V2.62499C11.3333 2.4243 11.4012 2.25607 11.537 2.1203C11.6727 1.98454 11.841 1.91666 12.0417 1.91666C12.2424 1.91666 12.4106 1.98454 12.5464 2.1203C12.6821 2.25607 12.75 2.4243 12.75 2.62499V3.33332H13.4583C13.8479 3.33332 14.1814 3.47204 14.4589 3.74947C14.7363 4.0269 14.875 4.36041 14.875 4.74999V14.6667C14.875 15.0562 14.7363 15.3897 14.4589 15.6672C14.1814 15.9446 13.8479 16.0833 13.4583 16.0833H3.54167ZM3.54167 14.6667H13.4583V7.58332H3.54167V14.6667ZM8.5 10.4167C8.29931 10.4167 8.13108 10.3488 7.99531 10.213C7.85955 10.0772 7.79167 9.90902 7.79167 9.70832C7.79167 9.50763 7.85955 9.3394 7.99531 9.20364C8.13108 9.06787 8.29931 8.99999 8.5 8.99999C8.70069 8.99999 8.86892 9.06787 9.00469 9.20364C9.14045 9.3394 9.20833 9.50763 9.20833 9.70832C9.20833 9.90902 9.14045 10.0772 9.00469 10.213C8.86892 10.3488 8.70069 10.4167 8.5 10.4167ZM5.66667 10.4167C5.46597 10.4167 5.29774 10.3488 5.16198 10.213C5.02622 10.0772 4.95833 9.90902 4.95833 9.70832C4.95833 9.50763 5.02622 9.3394 5.16198 9.20364C5.29774 9.06787 5.46597 8.99999 5.66667 8.99999C5.86736 8.99999 6.03559 9.06787 6.17135 9.20364C6.30712 9.3394 6.375 9.50763 6.375 9.70832C6.375 9.90902 6.30712 10.0772 6.17135 10.213C6.03559 10.3488 5.86736 10.4167 5.66667 10.4167ZM11.3333 10.4167C11.1326 10.4167 10.9644 10.3488 10.8286 10.213C10.6929 10.0772 10.625 9.90902 10.625 9.70832C10.625 9.50763 10.6929 9.3394 10.8286 9.20364C10.9644 9.06787 11.1326 8.99999 11.3333 8.99999C11.534 8.99999 11.7023 9.06787 11.838 9.20364C11.9738 9.3394 12.0417 9.50763 12.0417 9.70832C12.0417 9.90902 11.9738 10.0772 11.838 10.213C11.7023 10.3488 11.534 10.4167 11.3333 10.4167ZM8.5 13.25C8.29931 13.25 8.13108 13.1821 7.99531 13.0463C7.85955 12.9106 7.79167 12.7424 7.79167 12.5417C7.79167 12.341 7.85955 12.1727 7.99531 12.037C8.13108 11.9012 8.29931 11.8333 8.5 11.8333C8.70069 11.8333 8.86892 11.9012 9.00469 12.037C9.14045 12.1727 9.20833 12.341 9.20833 12.5417C9.20833 12.7424 9.14045 12.9106 9.00469 13.0463C8.86892 13.1821 8.70069 13.25 8.5 13.25ZM5.66667 13.25C5.46597 13.25 5.29774 13.1821 5.16198 13.0463C5.02622 12.9106 4.95833 12.7424 4.95833 12.5417C4.95833 12.341 5.02622 12.1727 5.16198 12.037C5.29774 11.9012 5.46597 11.8333 5.66667 11.8333C5.86736 11.8333 6.03559 11.9012 6.17135 12.037C6.30712 12.1727 6.375 12.341 6.375 12.5417C6.375 12.7424 6.30712 12.9106 6.17135 13.0463C6.03559 13.1821 5.86736 13.25 5.66667 13.25ZM11.3333 13.25C11.1326 13.25 10.9644 13.1821 10.8286 13.0463C10.6929 12.9106 10.625 12.7424 10.625 12.5417C10.625 12.341 10.6929 12.1727 10.8286 12.037C10.9644 11.9012 11.1326 11.8333 11.3333 11.8333C11.534 11.8333 11.7023 11.9012 11.838 12.037C11.9738 12.1727 12.0417 12.341 12.0417 12.5417C12.0417 12.7424 11.9738 12.9106 11.838 13.0463C11.7023 13.1821 11.534 13.25 11.3333 13.25Z"
                                    fill="#CDF545"
                                />
                            </svg>

                            <span>30.11.2024</span>
                        </div>
                        <div className="accordion-badge location-badge">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="18"
                                viewBox="0 0 17 18"
                                fill="none"
                            >
                                <path
                                    d="M8.50033 13.6219C8.35866 13.6219 8.21699 13.5983 8.07533 13.551C7.93366 13.5038 7.8038 13.433 7.68574 13.3385C6.29269 12.2288 5.2538 11.1456 4.56908 10.0891C3.88435 9.03245 3.54199 7.99652 3.54199 6.98124C3.54199 5.50555 4.00241 4.29252 4.92324 3.34218C5.84408 2.39183 7.03644 1.91666 8.50033 1.91666C9.96421 1.91666 11.1566 2.39183 12.0774 3.34218C12.9982 4.29252 13.4587 5.50555 13.4587 6.98124C13.4587 7.99652 13.1163 9.03245 12.4316 10.0891C11.7469 11.1456 10.708 12.2288 9.31491 13.3385C9.19685 13.433 9.06699 13.5038 8.92533 13.551C8.78366 13.5983 8.64199 13.6219 8.50033 13.6219ZM8.50033 8.29166C8.88991 8.29166 9.22342 8.15294 9.50085 7.87551C9.77828 7.59808 9.91699 7.26457 9.91699 6.87499C9.91699 6.48541 9.77828 6.1519 9.50085 5.87447C9.22342 5.59704 8.88991 5.45832 8.50033 5.45832C8.11074 5.45832 7.77724 5.59704 7.4998 5.87447C7.22237 6.1519 7.08366 6.48541 7.08366 6.87499C7.08366 7.26457 7.22237 7.59808 7.4998 7.87551C7.77724 8.15294 8.11074 8.29166 8.50033 8.29166ZM4.25033 16.0833C4.04963 16.0833 3.8814 16.0154 3.74564 15.8797C3.60987 15.7439 3.54199 15.5757 3.54199 15.375C3.54199 15.1743 3.60987 15.0061 3.74564 14.8703C3.8814 14.7345 4.04963 14.6667 4.25033 14.6667H12.7503C12.951 14.6667 13.1192 14.7345 13.255 14.8703C13.3908 15.0061 13.4587 15.1743 13.4587 15.375C13.4587 15.5757 13.3908 15.7439 13.255 15.8797C13.1192 16.0154 12.951 16.0833 12.7503 16.0833H4.25033Z"
                                    fill="#CDF545"
                                />
                            </svg>
                            <span>East Gate - Event Hall</span>
                        </div>
                    </div>
                    <div
                        className={isOpen ? "arrow-active" : ""}
                    >
                        {accordionArrow}
                    </div>
                </div>
            </div>

            <div
                ref={contentHeight}
                style={
                    isOpen
                        ? { height: contentHeight.current.scrollHeight }
                        : { height: "0px" }
                }
                className="accordion-container"
            >
                <div className="accordion-content">
                    <hr />

                    <div className="accordion-list-columns-wrapper">
                        <div className="accordion-list-column accordion-list-column-mobile">
                            <div className="accordion-list-item">
                                <h4 className="accordion-list-heading">
                                    локација
                                </h4>
                                <p className="accordion-list-paragraph">
                                    East Gate - Event Hall
                                </p>
                            </div>
                        </div>

                        <hr className="mobile-hr" />

                        <div className="accordion-list-column">
                            <div className="accordion-list-item">
                                <h4 className="accordion-list-heading">
                                    времетраење
                                </h4>
                                <p className="accordion-list-paragraph">
                                    90 Mинути
                                </p>
                            </div>

                            <div className="accordion-list-item">
                                <h4 className="accordion-list-heading">
                                    СТАРТ НА РУНДА
                                </h4>
                                <p className="accordion-list-paragraph">
                                    Започнуваат 150 натпреварувачи
                                </p>
                            </div>

                            <div className="accordion-list-item">
                                <h4 className="accordion-list-heading">
                                    КРАЈ НА РУНДА
                                </h4>
                                <p className="accordion-list-paragraph">
                                Продолжуваат само 50
                                натпреварувачи
                                </p>
                            </div>
                        </div>

                        <hr className="mobile-hr" />

                        <div className="accordion-list-column">
                            <div className="accordion-list-item">
                                <h4 className="accordion-list-heading">
                                    формат
                                </h4>
                                <p className="accordion-list-paragraph">
                                    25 Прашања со избор од понудени одговори
                                </p>
                            </div>

                            <div className="accordion-list-item">
                                <h4 className="accordion-list-heading">
                                комплексност
                                </h4>
                                <p className="accordion-list-paragraph">
                                    Напредно ниво математика за <br />
                                    средно образование
                                </p>
                            </div>

                            <div className="accordion-list-item">
                                <h4 className="accordion-list-heading">
                                    дозволени се
                                </h4>
                                <p className="accordion-list-paragraph">
                                    Калкулатори и листови за решавање
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Accordion;
